/**
 * A turn's continuation chips (Figma `LrdQopN1jNWKJFWxOkn0IY` node `360:14197`,
 * layer "Transcrição / chips de continuação"): drawn from the stream's own
 * `followups` event, never guessed from the tool that answered -- the chips'
 * text can quote detail (a window, a named bairro) only the answer just given
 * actually carries. No event yet, or none at all, draws no row.
 */

import { ArrowUpRight } from 'lucide-react';
import type { ReactNode } from 'react';

import { Chip } from '../../../ui/chip';
import { at } from './messages';
import type { TurnRecord } from './useConversation';

function followupOf(turn: TurnRecord): string[] {
  const event = turn.events.find(
    (candidate): candidate is Extract<typeof candidate, { kind: 'followups' }> =>
      candidate.kind === 'followups',
  );
  return event === undefined ? [] : event.data.chips;
}

export function FollowUps(props: {
  turn: TurnRecord;
  onAsk: (question: string) => void;
}): ReactNode {
  const questions = followupOf(props.turn);
  if (questions.length === 0) return null;

  return (
    <div
      role="group"
      aria-label={at('followups.group')}
      className="flex w-full flex-wrap items-center gap-1.5"
    >
      {questions.map((question) => (
        <button
          key={question}
          type="button"
          onClick={() => props.onAsk(question)}
          className="group rounded-full outline-none focus-visible:ring-3 focus-visible:ring-ring/50"
        >
          <Chip
            tone="outline"
            size="sm"
            icon={<ArrowUpRight aria-hidden />}
            className="group-hover:bg-accent group-active:bg-accent/80"
          >
            {question}
          </Chip>
        </button>
      ))}
    </div>
  );
}
